import { MessageToastService } from 'src/app/services/common/message-toast.service';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IUserForm, IUser, IUserQueryResult } from 'src/app/models/iuser.interface';
import { IKeyValue } from 'src/app/models/ikeyvalue.interface';
import { retryWithBackoff } from 'src/app/shared/operators/retryWithBackoff.operator';
import { catchError, shareReplay } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';

@Injectable()
export class UserService {
    private url = 'users';
    private api = environment.apiUrl;

    constructor(private http: HttpClient, private msg: MessageToastService) { }

    getAll(): Observable<IUser[]> {
        return this.http.get<IUser[]>(`${this.api}${this.url}`).pipe(
            // retryWithBackoff(1000, 3),
            catchError(err => {
                this.msg.errorEx(err);
                return EMPTY;
            }),
            shareReplay()
        );
    }

    getUsers(): Observable<IUser[]> {
      return this.http.get<IUser[]>(`${ this.api }${ this.url }/users`).pipe(
        catchError(err => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
    }

    getTable(filter: string): Observable<IUserQueryResult> {
        return this.http.get<IUserQueryResult>(`${this.api}${this.url}/table/?${filter}`).pipe(
            // retryWithBackoff(1000, 3),
            catchError(err => {
                this.msg.errorEx(err);
                return EMPTY;
            }),
            shareReplay()
        );
    }

    getAllKeyValue(): Observable<IKeyValue[]> {
        return this.http.get<IKeyValue[]>(`${this.api}${this.url}/kv`).pipe(
            // retryWithBackoff(1000, 3),
            catchError(err => {
                this.msg.errorEx(err);
                return EMPTY;
            }),
            shareReplay()
        );
    }

    getSingle(id: string): Observable<IUser> {
        return this.http.get<IUser>(`${this.api}${this.url}/${id}`).pipe(
            // retryWithBackoff(1000, 3),
            catchError(err => {
                this.msg.errorEx(err);
                return EMPTY;
            }),
            shareReplay()
        );
    }

    getSingleKeyValue(id: string): Observable<IKeyValue> {
        return this.http.get<IKeyValue>(`${this.api}${this.url}/${id}/kv`).pipe(
            // retryWithBackoff(1000, 3),
            catchError(err => {
                this.msg.errorEx(err);
                return EMPTY;
            }),
            shareReplay()
        );
    }

    update(id: string, obj: IUserForm): Observable<IUser> {
        return this.http.put<IUser>(`${this.api}${this.url}/${id}`, obj).pipe(
            // retryWithBackoff(1000, 3),
            catchError(err => {
                this.msg.errorEx(err);
                return EMPTY;
            }),
            shareReplay()
        );
    }

    add(obj: IUserForm): Observable<IUser> {
        return this.http.post<IUser>(`${this.api}${this.url}/`, obj).pipe(
            // retryWithBackoff(1000, 3),
            catchError(err => {
                this.msg.errorEx(err);
                return EMPTY;
            }),
            shareReplay()
        );
    }

    delete(id: string) {
        return this.http.delete(`${this.api}${this.url}/${id}`).pipe(
            // retryWithBackoff(1000, 3),
            catchError(err => {
                this.msg.errorEx(err);
                return EMPTY;
            }),
            shareReplay()
        );
    }
}
